import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    fetchRoles() {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/roles')
          .then(response => {
            const { data } = response.data
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
    putRole(ctx, { roleName, ability }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put('/roles', { name: roleName, ability })
          .then(response => {
            const { data } = response.data
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
  },
}
